import { render, staticRenderFns } from "./policySearch.vue?vue&type=template&id=82f4a89e&scoped=true&"
import script from "./policySearch.vue?vue&type=script&lang=js&"
export * from "./policySearch.vue?vue&type=script&lang=js&"
import style0 from "./policySearch.vue?vue&type=style&index=0&id=82f4a89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f4a89e",
  null
  
)

export default component.exports